/*
import HeaderTitle from './HeaderTitle';
import HeaderContainer from './HeaderContainer';

const DetailPageHeader = ({ title, image }) => {
	return (
		<HeaderContainer
			headerContent={
				<>
					<HeaderTitle image={image} alt={title} title={title} />
				</>
			}
		/>
	);
};

export default DetailPageHeader;
*/

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Button, Stack, Tooltip, Typography } from '@mui/material';
import HeaderCreateButton from 'components/button/HeaderCreateButton';
import { AutoIcon } from '../../assets/icons/common';

const DetailPageHeader = ({
	title,
	image,
	actions,
	tabsItem,
	selectedTab,
	selectTabHandler,
	onCreateHandler,
	onAuto,
	showAuto = false,
	createBtn = false,
	activeCreateButton = false,
	tabsFirst = false,
	autoFirst = false,
	disableAutoPin = false,
	pinStorageKey,
}) => {
	const { pathname } = useLocation();
	const resolvedPinStorageKey = pinStorageKey ?? `detail-page-header:auto:${pathname}`;
	const [isHeaderPinned, setIsHeaderPinned] = useState(() => sessionStorage.getItem(resolvedPinStorageKey) !== '0');

	useEffect(() => {
		const savedState = sessionStorage.getItem(resolvedPinStorageKey) !== '0';
		setIsHeaderPinned(savedState);
		if (typeof onAuto === 'function') {
			onAuto(savedState);
		}
	}, [resolvedPinStorageKey]);

	const handleTabClick = (event, index) => {
		if (typeof selectTabHandler !== 'function') return;

		if (selectTabHandler.length >= 2) {
			selectTabHandler(event, index);
		} else {
			selectTabHandler(index);
		}
	};

	const handleAutoClick = () => {
		const nextState = !isHeaderPinned;
		sessionStorage.setItem(resolvedPinStorageKey, nextState ? '1' : '0');
		setIsHeaderPinned(nextState);
		if (typeof onAuto === 'function') {
			onAuto(nextState);
		}
	};

	return (
		<Box
			sx={{
				mb: '22px',
				position: isHeaderPinned && !disableAutoPin ? 'sticky' : 'static',
				top: isHeaderPinned && !disableAutoPin ? '60px' : 'auto',
				zIndex: isHeaderPinned && !disableAutoPin ? 999 : 'auto',
				backgroundColor: isHeaderPinned && !disableAutoPin ? 'background.main' : 'transparent',
			}}
		>
			<Box
				sx={{
					py: 1.75,
					borderRadius: '16px',
					px: { xs: 2, sm: 2.5 },
					backgroundColor: '#FFFFFF',
					border: '1px solid #E5E7EB',
					boxShadow: '0 1px 6px rgba(15, 23, 42, 0.05)',
				}}
			>
				<Stack
					direction={{ xs: 'column', lg: 'row' }}
					alignItems={{ xs: 'flex-start', lg: 'center' }}
					justifyContent="space-between"
					gap={1.5}
				>
					<Stack direction="row" alignItems="center" sx={{ gap: '10px' }}>
						{/* {image ? (typeof image === 'string' ? <img alt={title} src={image} width="20px" height="18px" /> : image) : null} */}
						<Typography sx={{ fontSize: '18px', lineHeight: 1.2, fontWeight: 600, color: '#1f2937' }}>{title}</Typography>
					</Stack>

					<Stack
						direction="row"
						alignItems="center"
						flexWrap="wrap"
						justifyContent={{ xs: 'flex-start', lg: 'flex-end' }}
						gap={1}
						width={{ xs: '100%', lg: 'auto' }}
					>
						{showAuto && autoFirst && (
							<Tooltip title={isHeaderPinned ? 'Pinned' : 'Unpin'}>
								<Button
									onClick={handleAutoClick}
									aria-label={isHeaderPinned ? 'Unpin header' : 'Pin header'}
									sx={{
										minWidth: '36px',
										width: '36px',
										height: '36px',
										borderRadius: '10px',
										color: isHeaderPinned ? '#1D4ED8' : '#374151',
										border: `1px solid ${isHeaderPinned ? '#BFDBFE' : '#E5E7EB'}`,
										backgroundColor: isHeaderPinned ? '#EFF6FF' : '#FFFFFF',
									}}
								>
									<AutoIcon />
								</Button>
							</Tooltip>
						)}

						{tabsFirst && tabsItem?.length > 0 && (
							<Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.5}>
								{tabsItem?.map((item, index) => {
									const isSelected = selectedTab === index;

									return (
										<Button
											key={`${item?.label}-${index}`}
											onClick={(event) => handleTabClick(event, index)}
											sx={{
												px: 2,
												fontSize: '15px',
												fontWeight: 500,
												minHeight: '42px',
												boxShadow: 'none',
												borderRadius: '10px',
												textTransform: 'none',
												color: isSelected ? '#FFFFFF' : '#475569',
												backgroundColor: isSelected ? '#0F172A' : 'transparent',
												'&:hover': {
													boxShadow: 'none',
													backgroundColor: isSelected ? '#0F172A' : '#F8FAFC',
												},
											}}
										>
											{item?.label}
										</Button>
									);
								})}
							</Stack>
						)}

						{actions}

						{!tabsFirst && tabsItem?.length > 0 && (
							<Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.5}>
								{tabsItem?.map((item, index) => {
									const isSelected = selectedTab === index;

									return (
										<Button
											key={`${item?.label}-${index}`}
											onClick={(event) => handleTabClick(event, index)}
											sx={{
												px: 2,
												fontSize: '15px',
												fontWeight: 500,
												minHeight: '42px',
												boxShadow: 'none',
												borderRadius: '10px',
												textTransform: 'none',
												color: isSelected ? '#FFFFFF' : '#475569',
												backgroundColor: isSelected ? '#0F172A' : 'transparent',
												'&:hover': {
													boxShadow: 'none',
													backgroundColor: isSelected ? '#0F172A' : '#F8FAFC',
												},
											}}
										>
											{item?.label}
										</Button>
									);
								})}
							</Stack>
						)}

						{showAuto && !autoFirst && (
							<Tooltip title={isHeaderPinned ? 'Pinned' : 'Unpin'}>
								<Button
									onClick={handleAutoClick}
									aria-label={isHeaderPinned ? 'Unpin header' : 'Pin header'}
									sx={{
										minWidth: '36px',
										width: '36px',
										height: '36px',
										borderRadius: '10px',
										color: isHeaderPinned ? '#1D4ED8' : '#374151',
										border: `1px solid ${isHeaderPinned ? '#BFDBFE' : '#E5E7EB'}`,
										backgroundColor: isHeaderPinned ? '#EFF6FF' : '#FFFFFF',
									}}
								>
									<AutoIcon />
								</Button>
							</Tooltip>
						)}

						{createBtn && <HeaderCreateButton onCreateHandler={onCreateHandler} activeCreateButton={activeCreateButton} />}
					</Stack>
				</Stack>
			</Box>
		</Box>
	);
};

export default DetailPageHeader;
